
import { AppComponent } from '@sportyano/app.component';
import { AppConfig } from '@sportyano/app.config';
import { bootstrapApplication } from '@angular/platform-browser';

bootstrapApplication(AppComponent, AppConfig)
  .catch((err) => console.error(err));
 